<div *ngIf="informantForm">
    <div *ngIf="questionIndex === 0">
        <div [formGroup]="informantForm" class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-10">
                    <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
                        ngDefaultControl (change)="setQuestionInformant(informantForm.value.question)"
                        (change)="copyArr()">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-3 col-form-label">จำนวนระดับ<lifedi-require></lifedi-require></label>
                <div class="col-3">
                    <select class="custom-select form-control" formControlName="length" style="display: inline;"
                        (change)="addLength()">
                        <option *ngFor="let lv of ratingLength" [value]="lv">{{ lv }}</option>
                    </select>
                </div>
            </div>

            <div *ngIf="informantForm.value.length">
                <div *ngFor="let lv of informantFormArray.controls; let i = index" formArrayName="choices">
                    <div [formGroupName]="i" class="form-group row">
                        <label class="offset-1 col-1 col-form-label">
                            {{ informantForm.value.length > 7 ? i === 0 ? 'min' : 'max' : i+1 }}
                        </label>
                        <input class="form-control col-9" formControlName="choice_detail" type="text"
                            (change)="setChoiceInformant(lv.value.choice_detail, i)" (change)="copyArr()">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="questionIndex !== 0">
        <div class="mt-1">
            <div class="form-group row">
                <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
                <div class="col-10">
                    <input type="text" class="form-control" id="question" (change)="copyArr()"
                        [(ngModel)]="informantArray[questionIndex - 1].question" autocomplete="off" ngDefaultControl>
                </div>
            </div>

            <div *ngIf="informantArray[questionIndex - 1].length">
                <div *ngFor="let lv of informantArray[questionIndex - 1].choices; let i = index">
                    <div class="form-group row">
                        <label class="offset-1 col-1 col-form-label">
                            {{ informantArray[questionIndex - 1].length > 7 ? i === 0 ? 'min' : 'max' : i+1 }}
                        </label>
                        <input class="form-control col-9" (change)="copyArr()" [(ngModel)]="lv.choice_detail"
                            type="text">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>